var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Project__body"},[_c('div',{staticClass:"Settings__section"},[_c('h5',[_vm._v("Code")]),_c('pre',{staticStyle:{"width":"960px","white-space":"pre-wrap","overflow":"auto"}},[_vm._v(_vm._s(_vm.cssTemplate))])])])}
var staticRenderFns = []

export { render, staticRenderFns }